export default __webpack_public_path__ + "static/media/location-aigle-new-shad.59bd3333.png";